
import Network from 'infrastructure/js/modules/network';
import { createLabelHelper } from 'infrastructure/js/utils/labelHelper';
import * as assetService from '../../../services/Assets/assetService.js';
import * as locationsService from '../../../services/Locations/locationsService';
import {api as messageDialogApi} from '../../MessageDialog/messageDialogActions';
import {api as batchJobsApi} from '../../BatchJobs/batchJobsActions';


/////////////////////////////////////////
// ACTION TYPES - PUBLIC, FOR REDUCERS
export const actionTypes = {
};


////////////////////////////////////////////////////////////////
// PLAIN ACTION CREATORS - PRIVATE, FOR LOCAL DISPATCH ONLY
const actions = {
};

/////////////////////////////////////////////////////
// METHODS FOR JSX PROPS - PUBLIC, ALL THUNK TYPE
export let jsxActions = {};

jsxActions.init = function() {
  return function(dispatch, getState) {
    return api.fetchPageData(dispatch, getState)();
  };
};

jsxActions.getMultiAssetsDetails = function(data) {
  return function(dispatch, getState) {
    return api.getMultiAssetsDetails(dispatch, getState)(data);
  };
};

jsxActions.submit = function(data) {
  return function(dispatch, getState) {
    return api.submit(dispatch, getState)(data);
  }
};

jsxActions.processWithConfirmation = function(confirmationMsg, callback) {
  return function(dispatch, getState) {
    api.processWithConfirmation(dispatch, getState)(confirmationMsg, callback);
  }
};

/////////////////////////////////////////////////////////////////////////
// API METHODS - PUBLIC, FOR OTHER ACTION MODULES (and internal use)
export let api = {};

api.fetchPageData = function(dispatch, getState) {
  return function() {

    return locationsService.fetchActiveLocations()
      .then((response) => {
        if (!Network.isResponseValid(response)) {
          console.error('Fetch locations failed.', response);
          messageDialogApi.responseError(dispatch, getState)(response);
          return [];
        }
        return  response?.dataList ?? [];
      })
      .catch((err) => {
        console.error('Fetch locations failed.', err);
        messageDialogApi.responseError(dispatch, getState)();
        return [];
      });
  }
}

api.getMultiAssetsDetails = function(dispatch, getState) {
  return function(data) {

    return assetService.getMultiAssetsDetails({query: data} )
      .then ((response) => {

        if (!Network.isResponseValid(response)) {
          console.error('Get multi assets details failed', response);
          messageDialogApi.responseError(dispatch, getState)(response);
          return [];
        }
        return response.data?.assets?.dataList ?? [];

      })
      .catch((err) => {
        console.error('Get multi assets details failed', err);
        messageDialogApi.responseError(dispatch, getState)();
        return [];
      });
  }
};

api.processWithConfirmation = function(dispatch, getState) {
  return function (confirmationMsg, callback) {
      let title = confirmationMsg;
      let cancelFunc = messageDialogApi.close(dispatch, getState);
      let removeFunc = api.doProcess(dispatch, getState, callback);

      let desc = _getMessageDialogBuilder(title, cancelFunc, removeFunc);
      messageDialogApi.open(dispatch, getState)(desc);
  }
};

api.doProcess = function (dispatch, getState, callback) {
  return function () {
    messageDialogApi.close(dispatch, getState)();
    callback?.();
  };
};

api.submit = function(dispatch, getState) {
  return function (data) {

    return locationsService.startMoveAssets(data)
      .then((response) => {

        if (!Network.isResponseValid(response)) {
          console.error('Change location failed ', response);
          messageDialogApi.responseError(dispatch, getState)(response);
          return {};
        }

        let pollingRequest = 'batchJobs/JOB_EXECUTION_ID/status-with-printing';

        return batchJobsApi
          .runJob(dispatch, getState)(response.data, { pollingRequest })
          .then((jobResponse) => {

              if (!Network.isResponseValid(jobResponse)) {
                  console.error('Change location failed ', jobResponse);
                  messageDialogApi.responseError(dispatch, getState)(jobResponse);
                  return {};
              }

              return jobResponse.data ?? {};
          })
          .catch((error) => {
            console.error('runJob failed, catch error: ', error);
            messageDialogApi.showError(dispatch, getState)();
            return {};
          });
      })
      .catch((error) => {
        console.error( 'submit failed, catch error: ', error);
        messageDialogApi.showError(dispatch, getState)();
        return {};
      });
  }

};


/////////////////////////////////////////////////////////////////////////
// PRIVATE HELPERS

function _getMessageDialogBuilder(title, cancelFunc, removeFunc) {
  let dialogLabels = createLabelHelper('mat.dialog.');
  let buttons = [
    {
      id: 'cancel',
      text: dialogLabels.get('no'),
      action: cancelFunc,
    },
    {
      id: 'remove',
      text: dialogLabels.get('yes'),
      action: removeFunc,
    },
  ];

  let className = 'mobile-message-dialog';

  return { title, className, buttons, showTitleIcon: false };
}

